import { httpRequest } from "@services/http"

export interface TreeAd {
  id: number
  ad_id: number
  name: string
  status: string | null
}

export interface TreeAdGroup {
  id: number
  name: string
  audience_definition_id: number | null
  audience_name: string | null
  ads: TreeAd[]
}

export interface TreeLaunch {
  id: number
  name: string
  ad_groups: TreeAdGroup[]
}

export interface TreeObjective {
  id: number
  name: string
  launches: TreeLaunch[]
}

export interface EngagementTreeResponse {
  id: number
  name: string
  objectives: TreeObjective[]
}

export class CommandGetEngagementTree {
  async run(engagementId: number): Promise<EngagementTreeResponse> {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/tree/`
    return await httpRequest<EngagementTreeResponse>(url, { method: "GET" })
  }
}
